module.exports = __webpack_public_path__ + "img/beast3.53ffb7c5.png";